import styled from 'styled-components'
export const Btmtext = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    position: ${props=> props.position};
    bottom:0;
    left:0;
    width: 100%;
    height: calc(100vw*(56/375));
    background-color: #ffcf19;
    background-color:${props=> props.bg};
    font-size: calc(100vw*(16/375));
    line-height: calc(100vw*(56/375));
    letter-spacing: 0.25px;
    text-align: center;
    color: #4e4e4e;
    padding : 0 calc(100vw*(18/375));
`
export const Text = styled.span`
    cursor: pointer;
    font-weight: 500;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color:${props=>props.color};
`
export const Prev = styled.span`
    cursor: pointer;
    font-weight: 500;
    display: none;
    display: ${props=> props.display};
    align-items: center;
`
export const Arrow = styled.em`
    display:block;
    width: calc(100vw*(9/375));
    height: calc(100vw*(16/375));
    margin-right : calc(100vw*(9.5/375));
`
export const Arrow2 = styled(Arrow)`
    margin-left : calc(100vw*(9.5/375));
`